import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as rwData from "../../utils/rwData.js";
import * as resolveType from "../../utils/resolveType.js";

const DropdownField = observer((props) => {
  //========================================================================
  // Wert aus globalVars auslesen
  let value = rwData.readRcvValue(props.props.variable);
  let resolvedValue = value.value;

  // Array auflösen
  if (props.element.index !== undefined) {
    resolvedValue = resolveType.readArray(value.value, props.element.index);
  }

  // falls kein Wert vorhanden, dann 0 setzen
  if (resolvedValue === "") {
    resolvedValue = "0";
  }

  // Index als Wert aus globalVars
  let idx = Math.abs(parseInt(resolvedValue));

  if (!isFinite(idx)) {
    idx = 0;
  }

  let dropdownStates = [["", "", ""]];

  if (props.props.states && props.props.states.length > 0) {
    dropdownStates = props.props.states;
  }

  const [selectedState, setSelectedState] = useState(idx);

  useEffect(() => {
    setSelectedState(idx);
  }, [idx]);

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    setSelectedState(newValue);

    let valueToWrite = newValue.toString();

    // Array schreiben
    if (props.element.index !== undefined) {
      let baseType;
      if (value.type.includes("ARRAY_INT")) {
        baseType = "INT";
      } else if (value.type.includes("ARRAY_USINT")) {
        baseType = "INT";
      } else if (value.type.includes("ARRAY_REAL")) {
        baseType = "REAL";
      }
      valueToWrite = resolveType.writeArray(
        value.value,
        props.element.index,
        newValue.toString(),
        baseType
      );
    }

    // Wert in globalVars schreiben
    if (props.authWrite) {
      if (valueToWrite !== null) {
        rwData.writeValue(
          props.props.variable.toString(),
          valueToWrite,
          value.value
        );
        // console.log("DropdownField: ", valueToWrite);
      }
    }
  };

  //========================================================================
  // Grafische Darstellung
  return (
    <div>
      <select
        value={selectedState}
        onChange={handleChange}
        style={{
          ...props.style,
          visibility: props.props.visibility,
          cursor: "pointer",
        }}
        title={
          language.displayText(value.name) +
          (globalVars.cyclicUpdate || globalVars.editor
            ? "\n" + ("Variable: " + props.props.variable)
            : "")
        }
      >
        <option value="" disabled></option>
        {(() => {
          try {
            return dropdownStates.map((state, index) => (
              <option key={index} value={index}>
                {language.displayText(state)}
              </option>
            ));
          } catch (error) {
            console.error("Error during map:", error);
            return null; // Fallback to null or show a message/option
          }
        })()}
      </select>
    </div>
  );
});

export default DropdownField;
